import React from 'react';
import Link from 'next/link';

function PageBanner({
  pageTitle = '',
  breadcrumbTextOne = '',
  breadcrumbTextTwo = '',
  breadcrumbTextThree = null,
  breadcrumbTextFour = null,
  breadcrumbUrl = '',
  breadcrumbUrlTwo = null,
  breadcrumbUrlThree = null,
  className = '',
  bannerBtn = false,
  btnTitle = null,
  handleBannerClick = null,
  landing = true,
}) {
  return (
    <div className={`${className} page-title-area`}>
      <div className="container">
        <div className="page-title-content">
          {landing && (
            <>
              <h2>{pageTitle}</h2>
              <ul>
                <li>
                  <Link href={breadcrumbUrl}>
                    <a>{breadcrumbTextOne}</a>
                  </Link>
                </li>
                {breadcrumbTextThree ? (
                  <>
                    <li>
                      <Link href={breadcrumbUrlTwo}>
                        <a>{breadcrumbTextTwo}</a>
                      </Link>
                    </li>
                    {breadcrumbTextFour ? '' : <li>{breadcrumbTextThree}</li>}
                  </>
                ) : (
                  <li>{breadcrumbTextTwo}</li>
                )}
                {breadcrumbTextFour ? (
                  <>
                    <li>
                      <Link href={breadcrumbUrlThree}>
                        <a>{breadcrumbTextThree}</a>
                      </Link>
                    </li>
                    <li>{breadcrumbTextFour}</li>
                  </>
                ) : (
                  ''
                )}
              </ul>
            </>
          )}
          {bannerBtn ? (
            <a className="banner-button" onClick={handleBannerClick}>
              {btnTitle}
            </a>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}

export default PageBanner;
